import { assocIf } from '@btime/helpers'
import React from 'react'

import { useFormStateFormatter } from './_helpers/formatFormState'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useSaveTrigger } from './_requests/saveTrigger'
import { useTrigger } from './_load/TriggerLoader'
import Container from '../../../components/structure/Container'
import FolderAndNameBar from './form/FolderAndNameBar'
import Form from '../../../packages/kiti/components/form/form/Form'
import Line from '../../../packages/kiti/components/helpers/Line'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import Sentence from './form/Sentence'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../packages/kiti/components/presentation/Text'

const Wrapper = () => {
  const { initialState, cloneFromId } = useModalData() || {}

  const trigger = useTrigger()
  const [onSubmit, { loading, error }] = useSaveTrigger()

  const formState = useFormStateFormatter({
    ...trigger,
    ...initialState,
    ...assocIf(!!cloneFromId, 'id', undefined),
    ...assocIf(!!trigger?.configuration, 'configuration', { ...trigger?.configuration })
  })

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={formState}>
      <Scroll height="69vh" scroll scrollX direction="column">
        <Container>
          <Separator weight={22} />
          <FolderAndNameBar />
          <Separator weight={1} />
          <Sentence />
          <Separator weight={22} />
        </Container>
      </Scroll>
      <Line />

      <Separator paddingH={2}>
        {!trigger?.readOnly ? (
          <SubmitBar loading={loading} error={error} />
        ) : (
          <Text align="center" color="red" bold>
            Esse gatilho é customizado e não pode ser editado
          </Text>
        )}
      </Separator>
    </Form>
  )
}

export default Wrapper
